import * as React from 'react';

export interface IQuantitySelect {
    quantity: number;
    canAdd: boolean;
    canRemove: boolean;
    onSelectQuantity: (newQuantity) => void;
    componentClassName: string;
};

interface IDataLoaderState {
    loadingText: string;
    showStopAnimationButton: boolean;
    showAnimation: boolean;
    timeout: any;
};

class QuantitySelect extends React.PureComponent<IQuantitySelect, IDataLoaderState> {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className={this.props.componentClassName}>
                <button className={`ticket-selection-quantity minus`}
                    onClick={this._onMinusClick.bind(this)}
                    disabled={!this.props.canRemove}
                >
                    {/*todo make dynamic text*/}
                    <span className="visually-hidden">Decrease</span>
                    <svg role="presentation" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-minus" />' }} />
                </button>
                <p className="seat-info-prices-qty">{this.props.quantity}</p>

                <button className={`ticket-selection-quantity`}
                    onClick={this._onPlusClick.bind(this)}
                    disabled={!this.props.canAdd}
                >
                    {/*todo make dynamic text*/}
                    <span className="visually-hidden">Increase</span>
                    <svg role="presentation" dangerouslySetInnerHTML={{ __html: '<use xlink:href="#icon-plus" />' }} />
                </button>
            </div>
        );
    }

    _onPlusClick() {
        if (this.props.canAdd) {
            const newQuantity = this.props.quantity + 1;
            this.props.onSelectQuantity(newQuantity);
        }
    }

    _onMinusClick() {
        if (this.props.canRemove) {
            const newQuantity = this.props.quantity - 1;
            this.props.onSelectQuantity(newQuantity);
        }
    }
}

export default QuantitySelect;